// @flow
import { NoticiasActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    noticia: {},
    listaNoticias: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type NoticiasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { noticia?: {} | null, listaNoticias?: [] | null, loading?: boolean, +value ?: boolean };

const Noticias = (state: State = INIT_STATE, action: NoticiasAction): any => {
    // console.log(action);
    switch (action.type) {
        case NoticiasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case NoticiasActionTypes.GET_NOTICIA: {
                    return {
                        ...state,
                        noticia: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case NoticiasActionTypes.LIST_NOTICIAS: {
                    return {
                        ...state,
                        listaNoticias: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case NoticiasActionTypes.ADD_NOTICIA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case NoticiasActionTypes.UPDATE_NOTICIA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case NoticiasActionTypes.DELETE_NOTICIA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case NoticiasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case NoticiasActionTypes.GET_NOTICIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        noticia: {},
                        loading: false,
                    };
                }
                case NoticiasActionTypes.LIST_NOTICIAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaNoticias: [],
                        loading: false,
                    };
                }
                case NoticiasActionTypes.ADD_NOTICIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case NoticiasActionTypes.UPDATE_NOTICIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case NoticiasActionTypes.DELETE_NOTICIA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case NoticiasActionTypes.GET_NOTICIA:
            return { ...state, error: false, loading: true };
        case NoticiasActionTypes.LIST_NOTICIAS:
            return { ...state, error: false, loading: true };
        case NoticiasActionTypes.ADD_NOTICIA:
            return { ...state, error: false, loadingForm: true };
        case NoticiasActionTypes.UPDATE_NOTICIA:
            return { ...state, error: false, loadingForm: true };
        case NoticiasActionTypes.DELETE_NOTICIA:
            return { ...state, error: false, loading: true };
        case NoticiasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                noticia: {},
                listaNoticias: [],
                formSubmited: false
            };
        case NoticiasActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Noticias;
